import { TEST_ENV } from 'gleam-shared/helpers/env'
import { isPrimitive } from 'gleam-shared/helpers/nodash'

export default function deprecate(obj, deprecatedKey, message) {
  if (isPrimitive(obj)) {
    return obj
  }

  return new Proxy(obj, {
    get(target, key) {
      if (key === deprecatedKey && !TEST_ENV) {
        console.warn(message)
      }

      return target[key]
    }
  })
}
